// Sets file names for Bulma style file inputs that include a file-name segment
const handleFileName = (document) => {
  document.querySelectorAll(".file.has-name input.file-input").forEach((fileInput) => {
    fileInput.addEventListener("change", (ev) => {
      const fileNames = [];
      for (const file of ev.target.files) {
        fileNames.push(file.name);
      }
      ev.target.closest(".file.has-name").querySelector(".file-name").textContent =
        fileNames.join(", ");
    });
  });
};

// Allows drag and drop of files onto Bulma file inputs
const handleFileDrop = (document) => {
  document.querySelectorAll("label.file-label").forEach((el) => {
    // Prevent browser from opening file
    el.addEventListener("dragover", (ev) => ev.preventDefault());

    el.addEventListener("drop", (ev) => {
      // Prevent browser from opening file
      ev.preventDefault();

      const input = el.querySelector("input.file-input");
      const files = ev.dataTransfer.files;

      // The standard browser if this was a default input is to ignore this
      if (files.length > 1 && !input.multiple) {
        return;
      }

      input.files = files;
      // Setting the files this way does not trigger change event
      input.dispatchEvent(new Event("change"));
    });
  });
};

document.addEventListener("DOMContentLoaded", () => handleFileName(document));
document.addEventListener("partial:replace", (ev) => handleFileName(ev.container));

document.addEventListener("DOMContentLoaded", () => handleFileDrop(document));
document.addEventListener("partial:replace", (ev) => handleFileDrop(ev.container));
